import { useState } from 'react'
import { useOnlineStatus } from '@/hooks/pwa/useOnlineStatus'
import { usePendingMutations } from '@/hooks/pwa/usePendingMutations'
import { CloseIcon } from '@/icons'

export default function OfflineBanner() {
  const { isOnline } = useOnlineStatus()
  const { pausedCount } = usePendingMutations()
  const [dismissed, setDismissed] = useState(false)

  const hasPending = pausedCount > 0
  const showBanner = (!isOnline || hasPending) && !dismissed

  if (!showBanner) return null

  let message: string
  if (!isOnline && hasPending) {
    message = `You're offline. ${pausedCount} change${pausedCount !== 1 ? 's' : ''} will sync when you reconnect.`
  } else if (!isOnline) {
    message = "You're offline. Showing cached data."
  } else {
    message = `${pausedCount} change${pausedCount !== 1 ? 's' : ''} will sync when you reconnect.`
  }

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
      className="bg-yellow-600 text-white px-4 py-2 flex items-center justify-between"
    >
      <span className="text-sm">{message}</span>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 hover:bg-yellow-700 rounded transition-colors"
        aria-label="Dismiss"
      >
        <CloseIcon className="w-4 h-4" />
      </button>
    </div>
  )
}
